<template>
    <div>
        <top-navbar></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-lg-7">
                    <div class="card p-4">
                        <h2 class="mb-3">{{ $t('brand.login-title') }}</h2>
                        <p class="mb-0">{{ $t('brand.login-description') }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    }
</script>
